import React from "react";

/* ══ TOUR CARD · coach-mark sheet body ════════════════════
 *
 * Inline content rendered inside the expanded coach-mark
 * sheet. Two rendering modes:
 *
 *   overview — bullets are [{name, desc}] pairs, rendered
 *              as "name — brief description" lines
 *   action   — bullets are plain strings, rendered with a
 *              leading accent dot
 * ════════════════════════════════════════════════════════ */

export default function TourCard({ card, isRTL, moduleLabel }) {
  const title = isRTL ? card.titleAr : card.title;
  const intro = isRTL ? card.introAr : card.intro;
  const isOverview = card.kind === "overview";
  const items = isOverview
    ? (card.modules || [])
    : ((isRTL ? card.bulletsAr : card.bullets) || []);

  return (
    <>
      <div className="ob-eyebrow">{moduleLabel}</div>
      <h2 className="ob-title">{title}</h2>
      <p className="ob-dek">{intro}</p>
      {items.length > 0 && (
        <ul className={isOverview ? "ob-modlist" : "ob-bullets"}>
          {items.map((b, i) => (
            isOverview ? (
              <li key={i} className="ob-mod">
                <span className="ob-mod-name">{b.name}</span>
                <span className="ob-mod-dash">—</span>
                <span className="ob-mod-desc">{b.desc}</span>
              </li>
            ) : (
              <li key={i} className="ob-bullet">
                <span className="ob-bullet-dot" />
                <span>{b}</span>
              </li>
            )
          ))}
        </ul>
      )}
    </>
  );
}
